import { gql } from '@apollo/client';

export const GET_VANITY_DUPLICATE_COMPENSATION_CONFIG = gql`
  query getVanityDuplicateCompensationConfig {
    liveOps {
      id
      vanityDuplicateCompensationConfig {
        sticker
        profileFrame
        appSkin
        badge
        emoji
        emojiPack
      }
    }
  }
`;

export const UPDATE_VANITY_DUPLICATE_COMPENSATION_CONFIG = gql`
  mutation updateVanityDuplicateCompensationConfig($input: VanityDuplicateCompensationConfigInput!) {
    updateVanityDuplicateCompensationConfig(input: $input) {
      sticker
      profileFrame
      appSkin
      badge
      emoji
      emojiPack
    }
  }
`;

export const GET_CONTENT_PACK_DUPLICATE_COMPENSATION_CONFIG = gql`
  query getContentPackDuplicateCompensationConfig {
    liveOps {
      id
      contentPackDuplicateCompensationConfig {
        contentPack
      }
    }
  }
`;

export const UPDATE_CONTENT_PACK_DUPLICATE_COMPENSATION_CONFIG = gql`
  mutation updateContentPackDuplicateCompensationConfig(
    $input: ContentPackDuplicateCompensationConfigInput!
  ) {
    updateContentPackDuplicateCompensationConfig(input: $input) {
      contentPack
    }
  }
`;
